import React from "react";
import { Navigate } from "react-router-dom";
import { getStoredEmployee } from "../utils/panelSession";

function hasAccess(employee, required = [], requireAll = false, allowAdminRole = false) {
  const role = String(employee?.role || "").toLowerCase();
  if (role === "super_admin") return true;
  if (allowAdminRole && role === "admin") return true;

  const perms = Array.isArray(employee?.permissions) ? employee.permissions : [];
  const needed = Array.isArray(required) ? required.filter(Boolean) : [required].filter(Boolean);
  if (!needed.length) return true;

  if (requireAll) return needed.every((perm) => perms.includes(perm));
  return needed.some((perm) => perms.includes(perm));
}

export default function PageRouteGuard({
  required = [],
  requireAll = false,
  allowAdminRole = false,
  redirectTo = "/panel/dashboard",
  children,
}) {
  const employee = getStoredEmployee();
  if (!employee) return <Navigate to="/" replace />;

  if (!hasAccess(employee, required, requireAll, allowAdminRole)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
